<fury-page-layout mode="card">
    <fury-page-layout-header>
      <div class="top_heading">
        <fury-breadcrumbs [@fadeInRight]  current="Plan Price"></fury-breadcrumbs>
      </div>
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name='Plan Price' [columns]="columns" (filterChange)="onFilterChange($event)">
        <div style="position: relative;" class="filter">
          <button class="filter fury-column-filter" type="button" mat-icon-button (click)="showFilter()">
            <img src="../../../assets/img/filter.png" alt="filter"/>
          </button>
          <div class="filteringprt" *ngIf="isShowFilter">
            <form [formGroup]="filterForm">
            <h3 style="margin: 0;">Filter</h3>
            <mat-form-field appearance="outline">
              <mat-label>Search By</mat-label>
              <mat-select formControlName="searchBy">
                <mat-option *ngFor="let item of serchByValue" [value]="item?.value">{{item.title}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Search Type</mat-label>
              <mat-select formControlName="searchType">
                <mat-option *ngFor="let item of commonService.searchTypeValue" [value]="item?.value">{{item.title}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="btnprt">
              <button mat-button class="can-button" (click)="showFilter()">Cancel</button>
              <button mat-button class="sub-button" (click)="filterChange()">Search</button>
            </div>
          </form>
          </div>
        </div>
        <div class="actions">
          <button  mat-raised-button class="black" (click)="openClonePlanModal()">Clone Plan</button>
        </div>
        <div class="actions">
          <button class="create"  type="button" [routerLink]="['/plan-management/plan-price/plan-price-add']" mat-mini-fab color="primary">
            <mat-icon>add</mat-icon>
          </button>
        </div>
        <div class="table_container">
        <table [dataSource]="dataSource" mat-table matSort>
            <ng-container matColumnDef="actions" stickyEnd>
              <th *matHeaderCellDef class="actions-cell" mat-header-cell mat-sort-header>Actions</th>
              <td *matCellDef="let row;let i=index" class="actions-cell" mat-cell>
                <button type="button" mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                  <button mat-menu-item routerLink="/plan-management/plan-price/plan-price-edit/{{row?.planPriceId}}">
                    <span>Edit</span>
                  </button>
                  <button mat-menu-item routerLink="/plan-management/plan-price/view-plan-price/{{row?.planPriceId}}">
                    <span>View</span>
                  </button>
                  <button mat-menu-item (click)="deletePlanPrice('delete', row)">
                    <span>Delete</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>
            <ng-container matColumnDef="select" sticky>
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle() : null"
                              [checked]="selection.hasValue() && isAllSelected()"
                              [indeterminate]="selection.hasValue() && !isAllSelected()">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()"
                              (change)="$event ? selection.toggle(row) : null"
                              [checked]="selection.isSelected(row)">
                </mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="plan_optional_item_category">
              <th mat-header-cell *matHeaderCellDef>Plan Type</th>
              <td mat-cell *matCellDef="let element">
                {{element?.plan_optional_item_category?.title}}
              </td>
            </ng-container>
            <ng-container matColumnDef="plan_property_type">
              <th mat-header-cell *matHeaderCellDef>Property type</th>
              <td mat-cell *matCellDef="let element">
                {{element?.plan_property_type?.title}}
              </td>
            </ng-container>
            <ng-container matColumnDef="plan_property_size">
              <th mat-header-cell *matHeaderCellDef>Property size</th>
              <td mat-cell *matCellDef="let element">
                {{element?.plan_property_size?.title}}
              </td>
            </ng-container>
            <ng-container matColumnDef="displayMonthlyPrice">
              <th mat-header-cell *matHeaderCellDef>Displayed Monthly Pricing</th>
              <td mat-cell *matCellDef="let element">
                $ {{element?.displayMonthlyPrice | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="discountedMonthlyPrice">
              <th mat-header-cell *matHeaderCellDef>Discounted Monthly Pricing</th>
              <td mat-cell *matCellDef="let element">
                $ {{element?.discountedMonthlyPrice | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="displayYearlyPrice">
              <th mat-header-cell *matHeaderCellDef>Displayed Annual pricing</th>
              <td mat-cell *matCellDef="let element">
                $ {{element?.displayYearlyPrice | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="discountedYearlyPrice">
              <th mat-header-cell *matHeaderCellDef>Discounted Annual pricing</th>
              <td mat-cell *matCellDef="let element">
                $ {{element?.discountedYearlyPrice | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="displayTwoYearlyPrice">
              <th mat-header-cell *matHeaderCellDef>Displayed 2 Years Pricing</th>
              <td mat-cell *matCellDef="let element">
                $ {{element?.displayTwoYearlyPrice | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="discountedTwoYearlyPrice">
              <th mat-header-cell *matHeaderCellDef>Discounted 2 Years Pricing</th>
              <td mat-cell *matCellDef="let element">
                $ {{element?.discountedTwoYearlyPrice | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="displayThreeYearlyPrice">
              <th mat-header-cell *matHeaderCellDef>Displayed 3 Years Pricing</th>
              <td mat-cell *matCellDef="let element">
                $ {{element?.displayThreeYearlyPrice | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="discountedThreeYearlyPrice">
              <th mat-header-cell *matHeaderCellDef>Discounted 3 Years Pricing</th>
              <td mat-cell *matCellDef="let element">
                $ {{element?.discountedThreeYearlyPrice | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="displayFourYearlyPrice">
              <th mat-header-cell *matHeaderCellDef>Displayed 4 Years Pricing</th>
              <td mat-cell *matCellDef="let element">
                $ {{element?.displayFourYearlyPrice | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="discountedFourYearlyPrice">
              <th mat-header-cell *matHeaderCellDef>Discounted 4 Years Pricing</th>
              <td mat-cell *matCellDef="let element">
                $ {{element?.discountedFourYearlyPrice | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="displayFiveYearlyPrice">
              <th mat-header-cell *matHeaderCellDef>Displayed 5 Years Pricing</th>
              <td mat-cell *matCellDef="let element">
                $ {{element?.displayFiveYearlyPrice | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="discountedFiveYearlyPrice">
              <th mat-header-cell *matHeaderCellDef>Discounted 5 Years Pricing</th>
              <td mat-cell *matCellDef="let element">
                $ {{element?.discountedFiveYearlyPrice | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="monthlyFreeMonth">
              <th mat-header-cell *matHeaderCellDef>Monthly Free Month</th>
              <td mat-cell *matCellDef="let element">
                {{element?.monthlyFreeMonth | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="annuallyFreeMonth">
              <th mat-header-cell *matHeaderCellDef>Annually Free Month</th>
              <td mat-cell *matCellDef="let element">
                {{element?.annuallyFreeMonth | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="twoYearsFreeMonth">
              <th mat-header-cell *matHeaderCellDef>Two Years Free Month</th>
              <td mat-cell *matCellDef="let element">
                {{element?.twoYearsFreeMonth | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="threeYearsFreeMonth">
              <th mat-header-cell *matHeaderCellDef>Three Years Free Month</th>
              <td mat-cell *matCellDef="let element">
                {{element?.threeYearsFreeMonth | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="fourYearsFreeMonth">
              <th mat-header-cell *matHeaderCellDef>Four Years Free Month</th>
              <td mat-cell *matCellDef="let element">
                {{element?.fourYearsFreeMonth | number}}
              </td>
            </ng-container>
            <ng-container matColumnDef="fiveYearsFreeMonth">
              <th mat-header-cell *matHeaderCellDef>Five Years Free Month</th>
              <td mat-cell *matCellDef="let element">
                {{element?.fiveYearsFreeMonth | number}}
              </td>
            </ng-container>
            <tr *matHeaderRowDef="visibleColumns; sticky: true" mat-header-row></tr>
            <tr
              *matRowDef="let row; columns: visibleColumns | paginate: { id: 'server', itemsPerPage: pageSize, currentPage: pageIndex, totalItems: totalCount };"
              class="clickable route-animations-elements" mat-row></tr>
          </table>
          </div>
          <div *ngIf="itemList?.length === 0" style="padding: 10px 0; text-align:center;">
            No Plan price found.
          </div>
          
          <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
          showFirstLastButtons
          [selectConfig] = "selectConfig"
          [ngClass]="{'mat-pegig': pageSize === 9999}"
          aria-label="Select page of periodic elements">
      </mat-paginator>
      </fury-list>
  
    </fury-page-layout-content>
</fury-page-layout>

